import React from 'react'
import ReactMarkdown from 'react-markdown'
import cn from 'classnames'

const parseParagraphChild = (child, index) =>
  typeof child === 'string' ? <span key={index}>{child}</span> : child

const parseParagraph = children =>
  children.length > 0 ? children.map(parseParagraphChild) : children

function Markdown({ text, children, className }) {
  return (
    <ReactMarkdown
      parserOptions={{ commonmark: true }}
      className={cn('markdown-text', className)}
      components={{
        p({ children, node, ...rest }) {
          return <p {...rest}>{parseParagraph(children)}</p>
        }
      }}
    >
      {text || children}
    </ReactMarkdown>
  )
}

export default Markdown
